import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
const FavoritesNoAccount: React.FC<IconProps> = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 232 207" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.994 95.765c-2.513 2.528-6.36 2.676-9.164.711l-.177.178-5.109-5.156c-14.106-14.228-14.106-37.3 0-51.53a7.181 7.181 0 0110.214 0c2.827 2.844 2.827 7.46 0 10.303-8.459 8.541-8.459 22.384 0 30.917l5.109 5.156-.177.178c1.962 2.852 1.817 6.708-.696 9.243zm18.68-51.013c-2.828-2.844-2.828-7.459 0-10.302a7.162 7.162 0 0110.213 0c2.82 2.843 2.82 7.458 0 10.302a7.177 7.177 0 01-10.214 0zm140.547 67.362l-46.339 46.74a7.178 7.178 0 01-10.211 0 7.316 7.316 0 010-10.306l41.227-41.59 5.105-5.156c17.943-18.101 19.749-52.218 0-72.145-19.747-19.918-51.764-19.918-71.511 0l-5.055 5.101c-2.621 2.667-6.254 4.329-10.275 4.329-4.014 0-7.646-1.662-10.266-4.329l-5.057-5.1c-19.744-19.919-51.764-19.919-71.508 0-19.754 19.926-18.397 53.594 0 72.144l15.322 15.461 76.621 77.299c2.818 2.843 2.818 7.459 0 10.305a7.182 7.182 0 01-10.214 0l-40.868-41.22-51.082-51.533c-24.035-24.247-25.392-67.145 0-92.76 25.39-25.615 66.558-25.615 91.95 0l5.109 5.156 5.104-5.156c25.39-25.615 66.558-25.615 91.948 0 25.394 25.615 23.133 69.417 0 92.76zm-64.289 54.547c2.818 2.843 2.818 7.458 0 10.309a7.188 7.188 0 01-10.223 0c-2.818-2.851-2.818-7.466 0-10.309a7.186 7.186 0 0110.223 0z"
        fill="#4A6EFF"
      />
    </svg>
  );
};

const MemoFavoritesNoAccount = React.memo(FavoritesNoAccount);
export default MemoFavoritesNoAccount;
